import { OverviewMode, TileState } from './types'

/**
 * How a bento tile renders (ADR 0003 — "teaser ≠ empty"). Member mode ignores
 * the share flag; in public mode an explicitly OFF flag is a `teaser`
 * regardless of data.
 */
export const resolveTileState = (
	mode: OverviewMode,
	hasData: boolean,
	shareFlag?: boolean,
): TileState => {
	if (mode === 'public' && shareFlag === false) {
		return 'teaser'
	}
	return hasData ? 'detail' : 'empty'
}
